import { render, staticRenderFns } from "./hostChangeRequests.vue?vue&type=template&id=424d2e4e&scoped=true"
import script from "./hostChangeRequests.vue?vue&type=script&lang=js"
export * from "./hostChangeRequests.vue?vue&type=script&lang=js"
import style0 from "./hostChangeRequests.vue?vue&type=style&index=0&id=424d2e4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424d2e4e",
  null
  
)

export default component.exports